// FormErrorMessage. Untouched until #4366, so every error message was rendering as Chakra stock `red.500` at
// `fontSize: sm`. Matches the helper text metrics in Form.ts; only the colour differs.
export const FormError = {
  parts: ["text", "icon"],
  baseStyle: {
    text: {
      mt: "8px",
      px: "12px",
      fontFamily: "Larsseit",
      fontFeatureSettings: '"ss01" on, "ss02" on',
      fontSize: "12px",
      lineHeight: 1.4,
      letterSpacing: "-0.02em",
      color: "system.error",
    },
    icon: {
      color: "system.error",
    },
  },
}
